import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-level-info',
  templateUrl: './level-info.component.html',
  styleUrls: ['./level-info.component.css']
})
export class LevelInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
